export enum StationGeneration {
  MINI = 'mini',
  REGULAR = 'regular',
}

export const StationGenerationTitles = new Map<StationGeneration, string>([
  [StationGeneration.MINI, 'ARM'],
  [StationGeneration.REGULAR, 'Intel'],
]);
